export default __webpack_public_path__ + "static/media/discord-chat.73d702be.svg";